// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import GrowthOpportunities from '../components/Frontend/BenchmarkDetails/GrowthOpportunities/GrowthOpportunities';

export const growthOpportunitiesRoute = (
  <>
    <Route path="/growth_opportunitities" element={<MainLayout />}>
      <Route index element={<GrowthOpportunities />} />
    </Route>
  </>
);
